import { getDisplayValue } from "@/utils/value"

import type { IntervalItem, IntervalMeterIdentity } from "./interval.types"

export interface IntervalGridRecord extends IntervalItem {
  meter_code: string
}

type IntervalGridMeter = Pick<IntervalMeterIdentity, "label" | "meterProvider">

export const defaultIntervalRecordsSortParam = "start_datetime:desc"

export const defaultIntervalRecordsSortModel = [
  { field: "start_datetime", sort: "desc" as const },
]

export const intervalToGridRecord = (
  item: IntervalItem,
  meterLookupById: Map<string, IntervalGridMeter>
): IntervalGridRecord => {
  const meter = meterLookupById.get(String(item.meter_id))

  return {
    ...item,
    meter_code: getDisplayValue(meter?.label),
    provider_name: getDisplayValue(meter?.meterProvider),
  }
}

const gridFieldToApiSortField = {
  flow_direction: "flow_direction",
  meter_code: "meter_id",
  start_datetime: "start_datetime",
  value: "value",
} as const

type IntervalRecordsSortableField = keyof typeof gridFieldToApiSortField

const isIntervalRecordsSortableField = (
  field: string
): field is IntervalRecordsSortableField =>
  Object.hasOwn(gridFieldToApiSortField, field)

export const intervalRecordsGridFieldToSortParam = (
  field: string | undefined,
  sort: "asc" | "desc" | null | undefined
): string | undefined => {
  if (!sort || !field || !isIntervalRecordsSortableField(field)) {
    return undefined
  }

  return `${gridFieldToApiSortField[field]}:${sort}`
}
